import {
  COMMON_GET_LOCATIONS_BEGIN,
  COMMON_GET_LOCATIONS_SUCCESS,
  COMMON_GET_LOCATIONS_FAILURE,
} from './constants';

import { BFFAgent } from '../../../common/BFFAgent';

export function getLocations() {
  return async (dispatch, getState) => {

    dispatch({
      type: COMMON_GET_LOCATIONS_BEGIN,
    });

    try {
      const locations = await BFFAgent.Locations.getLocations();
      dispatch({
        type: COMMON_GET_LOCATIONS_SUCCESS,
        data: locations,
      });

    } catch {
      dispatch({
        type: COMMON_GET_LOCATIONS_FAILURE,
      });
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_LOCATIONS_BEGIN:
      return {
        ...state,
        locationsPending: true,
      };
    case COMMON_GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.data,
        locationsPending: false,
      };
    case COMMON_GET_LOCATIONS_FAILURE:
      return {
        ...state,
        locationsError: true,
        locationsPending: false,
      };

    default:
      return state;
  }
}
